module.exports = __webpack_public_path__ + "media/images/claim_profile/revenue-d2d371e525095bb59094e0ca478b4daf.png";